var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#ec7b47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-255 347 100 100",
    style: {
      enableBackground: "new -255 347 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M-205,367c16.6,0,30,13.4,30,30s-13.4,30-30,30s-30-13.4-30-30S-221.6,367-205,367 M-205,362   c-19.3,0-35,15.7-35,35s15.7,35,35,35s35-15.7,35-35S-185.7,362-205,362L-205,362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-214.7,417.5c-0.5,0-1-0.1-1.4-0.4c-1.2-0.8-1.5-2.3-0.7-3.5c3-4.6,7.6-7.9,12.9-9.3c5.3-1.4,10.9-0.9,15.8,1.6   c1.2,0.6,1.7,2.1,1.1,3.4c-0.6,1.2-2.1,1.7-3.4,1.1c-3.8-1.9-8.2-2.3-12.3-1.2c-4.1,1.1-7.7,3.7-10,7.2   C-213.1,417.1-213.9,417.5-214.7,417.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: -193,
    cy: 391,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -217,
    cy: 391,
    r: 5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.5c3521dab426df7de6e9655d5b81a60f.svg";
export { ForwardRef as ReactComponent };